import { Component, Inject } from '@angular/core';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { CoreLibModalComponent } from '../modal/modal.component';
import { UtilService } from 'app/shared/util.service';
@Component({
  selector: 'mh-whatsapp-welcome-modal',
  templateUrl: './whatsapp-welcome-modal.component.html',
  styleUrls: ['./whatsapp-welcome-modal.component.scss'],
  standalone: false
})
export class WhatsappWelcomeModalComponent extends CoreLibModalComponent {

  constructor(
    private utilService: UtilService,
    protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: any,
  ) {
    super(dialogRef, data);
  }

  onRejectGift(): void {
    this.utilService.ga('whatsapp', 'gift-whatsapp-reject');
    if (this.canPerformActions) {
      this.close({ action: 'reject' });
    }
  }

  onActivateNow(): void {
    this.utilService.ga('whatsapp', 'gift-whatsapp-activate');
    if (this.canPerformActions) {
      this.close({ action: 'activate' });
    }
  }

  get canPerformActions(): boolean {
    return this.data?.canPerformActions ?? false;
  }
}
